<template>
  <div id="downloadLogos">
      <Tab isLogos="true" />
      <section>
        <h1>デジタル向け(RGB)</h1>
        <p>映像やウェブサイト、ブログなどデジタルで使う場合にはこちらから</p>
        <ul class="cards">
          <li @click="openModal(2)" class="card"><Card imgSrc="card-thumbnail-full.svg" imgAlt="フルカラー" title="フルカラー" fileType="PNG, SVG, AI, ZIP" /></li>
          <li @click="openModal(3)" class="card"><Card imgSrc="card-thumbnail-white.svg" imgAlt="白抜き" title="白抜き" fileType="PNG, SVG, AI, ZIP" /></li>
        </ul>
      </section>
      <section>
        <h1>印刷向け(CMYK)</h1>
        <p>印刷物に使う場合にはこちらから</p>
        <ul class="cards">
          <li @click="openModal(6)" class="card"><Card imgSrc="card-thumbnail-full.svg" imgAlt="フルカラー" title="フルカラー" fileType="TIFF, AI, ZIP" /></li>
          <li @click="openModal(7)" class="card"><Card imgSrc="card-thumbnail-white.svg" imgAlt="白抜き" title="白抜き" fileType="TIFF, AI, ZIP" /></li>
        </ul>
      </section>
      <section>
        <h1>全部入りパッケージ</h1>
        <p>全タイプのロゴファイルをZipでまとめてダウンロードする場合はこちらから。</p>
        <ul class="cards">
            <li @click="openModal(8)" class="card"><Card imgSrc="card-thumbnail-all.svg" imgAlt="日本語 全ロゴファイル" title="日本語 全ロゴファイル" fileType="ZIP" /></li>
            <li @click="openModal(9)" class="card"><Card imgSrc="card-thumbnail-english.svg" imgAlt="ALL ENGLISH LOGOS" title="ALL ENGLISH LOGOS" fileType="ZIP" /></li>
        </ul>
      </section>
      <Modal :show="modalshow[2].show" @close="closeModal(2)" eyecatch="card-thumbnail-full.svg" title="RGBフルカラー" :files="[{filetype: 'PNG', filename: '00-Novasell-logo-RGB'},{filetype: 'SVG', filename: '00-Novasell-logo-RGB'},{filetype: 'AI', filename: '00-Novasell-logo-RGB'},{filetype: 'ZIP', filename: '00-Novasell-logo-RGB'}]" />
      <Modal :show="modalshow[3].show" @close="closeModal(3)" eyecatch="card-thumbnail-white.svg" title="RGB白抜き" :files="[{filetype: 'PNG', filename: '01-Novasell-logo-white-RGB'},{filetype: 'SVG', filename: '01-Novasell-logo-white-RGB'},{filetype: 'AI', filename: '01-Novasell-logo-white-RGB'},{filetype: 'ZIP', filename: '01-Novasell-logo-white-RGB'}]"  />
      <Modal :show="modalshow[6].show" @close="closeModal(6)" eyecatch="card-thumbnail-full.svg" title="CMYKフルカラー" :files="[{filetype: 'TIFF', filename: '00-Novasell-logo-CMYK'},{filetype: 'AI', filename: '00-Novasell-logo-CMYK'},{filetype: 'ZIP', filename: '00-Novasell-logo-CMYK'}]" />
      <Modal :show="modalshow[7].show" @close="closeModal(7)" eyecatch="card-thumbnail-white.svg" title="CMYK白抜き" :files="[{filetype: 'TIFF', filename: '01-Novasell-logo-white-CMYK'},{filetype: 'AI', filename: '01-Novasell-logo-white-CMYK'},{filetype: 'ZIP', filename: '01-Novasell-logo-white-CMYK'}]"  />
      <Modal :show="modalshow[8].show" @close="closeModal(8)" eyecatch="card-thumbnail-all.svg" title="日本語 全ロゴファイル" :files="[{filetype: 'ZIP', filename: 'Novasell-logo-Japanese'}]" />
      <Modal :show="modalshow[9].show" @close="closeModal(9)" eyecatch="card-thumbnail-english.svg" title="ALL ENGLISH LOGOS" :files="[{filetype: 'ZIP', filename: 'Novasell-logo-English'}]"  />
  </div>
</template>

<script>
import Tab from '../Atoms/Tab'
import Card from '../Molecules/Card'
import Modal from '../Organisms/Modal'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DownloadLogos',
  components: {
    Tab,
    Card,
    Modal
  },
  data () {
    return {
      modalshow: [
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false},
        {show: false}
      ]
    }
  },
  mounted: function () {
    this.scrollItem()
  },
  methods: {
    openModal: function (val) {
      this.modalshow[val].show = true
    },
    closeModal: function (val) {
      this.modalshow[val].show = false
    },
    scrollItem: function () {
      const tl = gsap.utils.toArray('.cards')
      tl.forEach((el, i) => {
        gsap.from(el.children, {
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            end: 'top center',
            markers: false
          },
          y: 48,
          opacity: 0,
          duration: 0.3,
          stagger: 0.1,
          ease: 'power2.inOut'
        })
      })
    }
  }
}
</script>

<style scoped>
section {
    margin-top: 9.6rem;
}
h1 {
    font-size: var(--jumbo-font-size);
    font-weight: var(--bold-font-weight);
    line-height: 1.5;
    margin-bottom: 1.6rem;
}
p {
    font-size: var(--normal-font-size);
    line-height: 2;
}
ul {
    margin-top: 4.8rem;
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(27rem, 1fr));
    gap: 3.2rem;
}

li:last-child {
    margin: 0;
}

.test {
  background: tomato;
  width: 200px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/DownloadLogos.vue